import * as React from 'react';
import { toastr } from "react-redux-toastr";
import * as _ from 'lodash'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { IMapCenter } from '../../../../share/types/common';
export interface IAgencyCountry {
    countryCode: string,
    code: string
}

export interface IOnSelectChange {
    center?: IMapCenter;
    countryCode?: string;
    countryName?: string;
    state?: string;
    city?: string;
}

export const initialSelectChange: IOnSelectChange = {
    center: undefined,
    countryCode: undefined,
    countryName: undefined,
    state: undefined,
    city: undefined,
}

export interface ISearchBarProps {
    onSelect: (change: IOnSelectChange) => void
    onChange: (address: string) => void
    name?: string;
    required?: boolean;
    address: string;
    agency: IAgencyCountry | null;
    agencyCode: string;
    disabled: boolean;
}
export interface ISearchBarState {
    address: string,
    countriesCodes: string[]
}
export class SearchBar extends React.Component<ISearchBarProps, ISearchBarState> {
    constructor(props) {
        super(props);
        this.state = { address: '', countriesCodes: [] };
    }

    public setAddress = (address) => {
        if (!address) {
            this.props.onSelect(_.cloneDeep(initialSelectChange))
        }
        this.props.onChange(address)
    }
    public static getDerivedStateFromProps(props: ISearchBarProps): Partial<ISearchBarState> {
        const countriesCodes = props.agency ? [props.agency.countryCode] : [];
        return { countriesCodes };
    }
    public handleSelect = address => {
        this.setAddress(address)
        return geocodeByAddress(address).then(this.onSelectChange)
            .catch(error => {
                toastr.error("Error", "There was an error fetching the location data")
            });
    };
    public onSelectChange = async (results) => {
        const { address_components, formatted_address } = results[0];
        const countryInfo = address_components.find((ac) => ac.types.find(type => type === "country"));
        const state = address_components.find((ac) => ac.types.find(type => type === "administrative_area_level_1")) || {};
        const city = address_components.find((ac) => ac.types.find(type => type === "locality")) || {};
        if (this.state.countriesCodes.indexOf(countryInfo.short_name) >= 0) {
            this.setAddress(formatted_address)
            const center = await getLatLng(results[0]);
            const change: IOnSelectChange = {
                center,
                countryCode: countryInfo.short_name,
                countryName: countryInfo.long_name,
                state: state.short_name,
                city: city.long_name
            }
            this.props.onSelect(change)
        }
    }
    public render() {
        const inputProps = {
            type: 'text',
            value: this.props.address,
            onChange: this.setAddress,
            required: true,
            name: 'searchbar',
        }
        const options = this.state.countriesCodes ? {
            searchOptions: {
                componentRestrictions: { country: this.state.countriesCodes }
            }
        } : {};
        const noCountryCodes = !this.state.countriesCodes || this.state.countriesCodes.length === 0
        return (
            <div className="searchBar">
                <PlacesAutocomplete inputProps={inputProps} {...inputProps} onSelect={this.handleSelect} {...options} >
                    {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                        <div>
                            <input
                                {...getInputProps({
                                    placeholder: noCountryCodes ? "Select a case" : 'City, state or zip',
                                    className: 'form-control',
                                    name: this.props.name,
                                    required: this.props.required,
                                    disabled: noCountryCodes || this.props.disabled || this.state.countriesCodes.length === 0
                                })}
                            />
                            <div className="autocomplete-dropdown-container">
                                {loading && <div className="suggestion-item">Loading...</div>}
                                {suggestions.map((suggestion, key) => {
                                    const className = `suggestion-item ${suggestion.active ? 'active' : ''}`
                                    return (
                                        <div key={key} {...getSuggestionItemProps(suggestion, { className })}>
                                            <span>{suggestion.description}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </PlacesAutocomplete>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/Alert/Create/components/SearchBar.tsx